/**
 * @generated SignedSource<<62413369f8852017a88bbc4c86f512ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExportTasksMode = "BACKUP" | "MIGRATION" | "%future added value";
export type ExportJsonDialogQuery$variables = {
  from: string;
  memberIds?: ReadonlyArray<string> | null | undefined;
  mode: ExportTasksMode;
  projectIds?: ReadonlyArray<string> | null | undefined;
  to: string;
};
export type ExportJsonDialogQuery$data = {
  readonly exportTasks: {
    readonly exportedAt: string;
    readonly integritySignature: string;
    readonly members: ReadonlyArray<{
      readonly email: string;
      readonly id: string;
      readonly name: string;
    }>;
    readonly mode: ExportTasksMode;
    readonly projects: ReadonlyArray<{
      readonly color: string | null | undefined;
      readonly currency: string;
      readonly hourlyRate: number;
      readonly id: string;
      readonly name: string;
      readonly status: string;
    }>;
    readonly range: {
      readonly from: string;
      readonly to: string;
    };
    readonly sourceWorkspaceId: string;
    readonly tasks: ReadonlyArray<{
      readonly date: string | null | undefined;
      readonly duration: number | null | undefined;
      readonly memberId: string | null | undefined;
      readonly projectId: string | null | undefined;
      readonly projectName: string | null | undefined;
      readonly title: string;
    }>;
  };
};
export type ExportJsonDialogQuery = {
  response: ExportJsonDialogQuery$data;
  variables: ExportJsonDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "memberIds",
        "variableName": "memberIds"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "projectIds",
        "variableName": "projectIds"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "ExportTasksPayload",
    "kind": "LinkedField",
    "name": "exportTasks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exportedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceWorkspaceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integritySignature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExportTasksRange",
        "kind": "LinkedField",
        "name": "range",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "from",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "to",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExportTaskItem",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExportProjectItem",
        "kind": "LinkedField",
        "name": "projects",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourlyRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExportMemberItem",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExportJsonDialogQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExportJsonDialogQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "9322517f6e8ff8ba2ff663d8437ef7e2",
    "id": null,
    "metadata": {},
    "name": "ExportJsonDialogQuery",
    "operationKind": "query",
    "text": "query ExportJsonDialogQuery(\n  $from: String!\n  $to: String!\n  $projectIds: [ID!]\n  $memberIds: [ID!]\n  $mode: ExportTasksMode!\n) {\n  exportTasks(from: $from, to: $to, projectIds: $projectIds, memberIds: $memberIds, mode: $mode) {\n    exportedAt\n    mode\n    sourceWorkspaceId\n    integritySignature\n    range {\n      from\n      to\n    }\n    tasks {\n      date\n      title\n      duration\n      projectId\n      projectName\n      memberId\n    }\n    projects {\n      id\n      name\n      hourlyRate\n      currency\n      color\n      status\n    }\n    members {\n      id\n      name\n      email\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "40ae7b6344cad5e8db49f699d4778dbd";

export default node;
